import { createStore } from 'effector';
import {
  deleteEntityContactFX,
  updateEntityContactFX,
  validateEntityContactFX,
} from '../entities/effects';
import { updateUserContactsFX, validateUserContactFX } from '../user/effects';
import { updateNestedContacts } from '../contacts/helpers/updateContacts';
import { PartnerOrganizationStore } from './interfaces';
import { deletePartnerOrganizationContactFX, fetchPartnerOrganizationProfileFX } from './effects';

export const $partnerOrganizationStore = createStore<PartnerOrganizationStore>({ profile: null });

$partnerOrganizationStore
  .on(fetchPartnerOrganizationProfileFX.doneData, (state, payload) => ({
    ...state,
    profile: payload.data,
  }))
  .on(deleteEntityContactFX.doneData, (state, payload) => updateNestedContacts(state, payload.data))
  .on(validateEntityContactFX.doneData, (state, payload) => updateNestedContacts(state, payload))
  .on(updateEntityContactFX.doneData, (state, payload) => updateNestedContacts(state, payload.data))
  .on(updateUserContactsFX.doneData, (state, payload) => updateNestedContacts(state, payload.data))
  .on(validateUserContactFX.doneData, (state, payload) => updateNestedContacts(state, payload))
  .on(deletePartnerOrganizationContactFX.doneData, (state, payload) =>
    updateNestedContacts(state, payload.data)
  );
